import { MembershipWithTeam } from 'shared/base';

export function getTeamMembershipMock(): MembershipWithTeam {
  return {
    role: 'admin',
    team: {
      display_name: 'Test team',
      internal: false,
      is_trial_active: false,
      name: 'testteam',
      plan: 'free',
    },
  };
}
